"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareSettingPanelHeader = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var c = (0, BemBuilder_1.default)("share-setting-panel-header");
var ShareSettingPanelHeader = function (props) {
    return (react_1.default.createElement("div", { className: c("action") },
        react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.ArrowLeft, null), type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () { return props.handleSettingSelect(false); } }),
        react_1.default.createElement("div", { className: c("action-label") }, props.settingTitle),
        props.helpTooltipContent && (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: props.helpTooltipContent, targetClassName: c("help"), size: kaleidoscope_1.TooltipSize.Large },
            react_1.default.createElement(icons_1.Help, { className: c("help", "icon") })))));
};
exports.ShareSettingPanelHeader = ShareSettingPanelHeader;
